module.exports = __webpack_public_path__ + "static/media/IMG_4731.50e2a13e.JPG";